'use client';

import type { PageRizAffiliateSchema } from '@/sanity/pages/PageRizAffiliateTemplate';
import { measuredRichText, V3_HIGHLIGHT } from './richtext';
import { RevealEyebrow, RevealRichText, RevealStyles } from './about/reveal';
import FAQListNewWebsite from './FAQListNewWebsite';

const HEADING_CLASS = `${V3_HIGHLIGHT} richtext richtext-center prose-headings:text-black prose-headings:font-geist prose-headings:font-[500] prose-headings:text-[4.5rem] prose-headings:tracking-[-0.225rem] lg:prose-headings:text-[6rem] lg:prose-headings:tracking-[-0.3rem] [--hl-tracking:-0.03em] [--hl-wash:5rem] lg:[--hl-wash:6.75rem] [--hl-dy:0.125rem] lg:[--hl-dy:0rem] [--hl-pl:0.5rem] lg:[--hl-pl:0.925rem] [--hl-ml:1.5rem] [&_span]:!text-black prose-headings:leading-[1.15]`;

export default function FAQSection({
  data,
}: {
  data: PageRizAffiliateSchema;
}) {
  if (!data?.faqChip && !data?.faqHeading?.length && !data?.faqItems?.length)
    return null;

  return (
    <section className="relative w-full bg-white py-[8rem] lg:py-[13.75rem]">
      <RevealStyles />
      <div className="flex flex-col items-center mx-auto w-[min(80rem,calc(100%-4rem))] gap-[4rem] lg:gap-[2.75rem]">
        {(data?.faqChip || data?.faqHeading?.length > 0) && (
          <div className="flex flex-col items-center gap-[2rem] lg:gap-[1.5rem]">
            <RevealEyebrow text={data?.faqChip} />
            <RevealRichText
              value={data?.faqHeading}
              components={measuredRichText}
              className={HEADING_CLASS}
            />
          </div>
        )}

        {data?.faqItems?.length > 0 && (
          <FAQListNewWebsite
            faq={data.faqItems}
            className="w-full"
          />
        )}
      </div>
    </section>
  );
}
